import React from 'react'
import { SubProjectsProps } from './SubProjects.types'
import styles from './SubProjects.module.scss'
import cl from 'classnames'
import { Button, HorizontalLine, NoneLabel, Text1 } from 'components/shared'
import { inject } from 'mobx-react'
import { PROJECT_PAGE_STORE } from 'store'
import { observer } from 'mobx-react-lite'
import { ProjectTypes } from 'models'
import { SubProjectLine } from './SubProjectLine'

const SubProjectsComponent = (props: SubProjectsProps) => {
  const {
    [PROJECT_PAGE_STORE]: {
      project: {
        type,
        children
      },
      onAddSubProjectClick
    }
  } = props

  if (
    ![ProjectTypes.TV_SERIES, ProjectTypes.TV_SEASON].includes(type)
  ) return null

  const hasChildren = Boolean(children && children.length)

  const subProjectName = {
    [ProjectTypes.TV_SERIES]: 'Season',
    [ProjectTypes.TV_SEASON]: 'Episode'
  }[type] as string

  return (
    <>
      <HorizontalLine style={{ marginTop: 30 }} />
      <Text1 bold className={styles.header}>
        {subProjectName}s

        <Button
          preset='secondary'
          onClick={onAddSubProjectClick}
        >
          Add {subProjectName.toLowerCase()}
        </Button>
      </Text1>

      {hasChildren
        ? (
          <div className={cl(styles.subProjects, styles.scrollable)}>

            {children.map(p => {
              return (
                <SubProjectLine
                  key={p.id}
                  project={p}
                />
              )
            })}

          </div>
        )
        : <NoneLabel />
      }

    </>
  )
}

const SubProjects = inject(PROJECT_PAGE_STORE)(observer(SubProjectsComponent))
export { SubProjects }
